"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowCellPersonProperty = exports.resultsTableRowCellPersonPropertyDefinition = void 0;
exports.resultsTableRowCellPersonPropertyDefinition = {
    view: { label: 'Results Table Row Cell Person' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'oneOfProperties',
            argument: ['results-table-cell-value-text', 'results-table-cell-value-person'],
        },
    ],
    type: 'one-of-container',
    multiple: true,
    name: 'results-table-row-cell-person',
};
const isResultsTableRowCellPersonProperty = (prop) => {
    return prop.name === exports.resultsTableRowCellPersonPropertyDefinition.name;
};
exports.isResultsTableRowCellPersonProperty = isResultsTableRowCellPersonProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3ctY2VsbC1wZXJzb24ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLXJvdy1jZWxsLXBlcnNvbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDJDQUEyQyxHQUFHO0lBQ3pELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSwrQkFBK0IsRUFBRTtJQUNoRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxpQkFBaUI7WUFDdkIsUUFBUSxFQUFFLENBQUMsK0JBQStCLEVBQUUsaUNBQWlDLENBQUM7U0FDL0U7S0FDRjtJQUNELElBQUksRUFBRSxrQkFBa0I7SUFDeEIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsK0JBQStCO0NBQ04sQ0FBQTtBQUkxQixNQUFNLG1DQUFtQyxHQUFHLENBQUMsSUFBa0IsRUFBNkMsRUFBRTtJQUNuSCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssbURBQTJDLENBQUMsSUFBSSxDQUFBO0FBQ3ZFLENBQUMsQ0FBQTtBQUZZLFFBQUEsbUNBQW1DLHVDQUUvQyJ9